import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import BarChart from '../common/Charts/BarChart';
import { numberWithCommas } from '../../util/CommonUtils';
import {
  IMAGES,
  calculateAsterisk,
  isMRISpecificStudy,
  checkAsterickFormate,
  calculateMRIAsterisk,
} from '../../util/QuickReportsUtils';
import ChannelCategoryTable from './ChannelCategoryTable';
import { MODULE_CHANNEL_CATEGORY } from '../../constants';
import QuickReportFootNote from './QuickReportFootNotes';

const ReportTypes = [
  { label: 'Combined Website Categories', imgSrc: IMAGES.ICON_pcm },
  { label: 'Mobile Website Categories', imgSrc: IMAGES.ICON_m },
  { label: 'PC Website Categories', imgSrc: IMAGES.ICON_pc },
];

const ReportDropdown = [
  { key: 'CCAT_7', value: '7 Days' },
  { key: 'CCAT_30', value: '30 Days' },
];

const ReportCategories = [5, 10, 15, 20];

const ChartColors = [
  '#247BA0',
  '#FFE066',
  '#F25F5C',
  '#4ECDC4',
  '#008490',
  '#F67451',
  '#E1D2A5',
  '#94D3DC',
  '#5CA4A9',
  '#FAB266',
];

export default class ChannelCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLabels: true,
      selectedRadioButtonDefault: 'Percent',
      selectedRadioButton: 'PC Website Categories',
      selectedCatgoriesRadioButton: '10',
      selectedDropdown: 'CCAT_7',
      selectedDropdownValue: '7 Days',
      displayTable: false,
      showSingleAsterisk: false,
      showDoubleAsterisk: false,
      data: this.props.data,
      tableData: {},
      event: {},
      tableTitle: {},
    };
  }

  componentDidMount() {
    this.props.handletitle('Channel Category by Percentage: 7 Days');
    this.props.handleExportParams(
      this.state.selectedRadioButtonDefault,
      this.getExportSubType(),
      undefined,
      undefined,
      undefined,
      this.state.selectedCatgoriesRadioButton
    );
    this.props.trackerFn({ subModule: MODULE_CHANNEL_CATEGORY });
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.state.showSingleAsterisk = false;
    this.state.showDoubleAsterisk = false;
    if (
      this.state.displayTable ||
      nextProps.reportName === 'CCAT_7D' ||
      nextProps.reportName === 'CCAT_30D'
    ) {
      this.setState({
        tableData: nextProps.data,
      });
    } else {
      const { selectedDropdown } = this.state;
      const selectedDropdownValue =
        selectedDropdown === 'CCAT_7' ? '7 Days' : '30 Days';
      this.setState(
        {
          data: nextProps.data,
          selectedDropdownValue,
        },
        () => {
          this.props.handleExportParams(
            this.state.selectedRadioButtonDefault,
            this.getExportSubType(),
            undefined,
            undefined,
            undefined,
            this.state.selectedCatgoriesRadioButton
          );
        }
      );
    }
  }

  getExportSubType() {
    let result;

    if (this.state.selectedRadioButton === 'PC Website Categories') {
      result = 'PC';
    } else if (this.state.selectedRadioButton === 'Mobile Website Categories') {
      result = 'Mobile';
    } else if (
      this.state.selectedRadioButton === 'Combined Website Categories'
    ) {
      result = 'Combined';
    }

    return result;
  }

  handleReportTypeRadioButtonChange = e =>
    this.setState({ selectedRadioButton: e.currentTarget.value }, () =>
      this.props.handleExportParams(
        this.state.selectedRadioButtonDefault,
        this.getExportSubType(),
        undefined,
        undefined,
        undefined,
        this.state.selectedCatgoriesRadioButton
      )
    );

  handleCatRadioButtonChange = e =>
    this.setState({ selectedCatgoriesRadioButton: e.currentTarget.value }, () =>
      this.props.handleExportParams(
        this.state.selectedRadioButtonDefault,
        this.getExportSubType(),
        undefined,
        undefined,
        undefined,
        this.state.selectedCatgoriesRadioButton
      )
    );

  handleDropdownChange = e => {
    let titile = '';
    if (e.currentTarget.value === 'CCAT_7') {
      titile = '7 Days';
    } else {
      titile = '30 Days';
    }
    this.setState({ selectedDropdown: e.currentTarget.value });
    this.props.runReport(null, null, e.currentTarget.value);
    // this.state.selectedDropdownValue
    this.props.handletitle(`Channel Category by Percentage: ${titile}`);
  };

  hideTable = () => this.setState({ displayTable: false, tableData: {} });

  arrangeDataCatWise = Data => {
    const outObj = [];
    const mobileData = []; // Data[1];
    const pcData = [];
    const combinData1 = [];
    const category = this.processDataCategoryWise();

    Object.keys(category).forEach(obj => {
      const label = String(obj);
      for (let j = 0; j < Data[0].data.length; j += 1) {
        const labelM = Data[0].data[j].name.split(':')[0];
        if (label.valueOf().trim() === labelM.valueOf().trim()) {
          combinData1.push(Data[0].data[j]);
        }
      }
      for (let j = 0; j < Data[1].data.length; j += 1) {
        const labelM = Data[1].data[j].name.split(':')[0];
        if (label.valueOf().trim() === labelM.valueOf().trim()) {
          mobileData.push(Data[1].data[j]);
        }
      }
      for (let j = 0; j < Data[2].data.length; j += 1) {
        const labelM = Data[2].data[j].name.split(':')[0];
        if (label.valueOf().trim() === labelM.valueOf().trim()) {
          pcData.push(Data[2].data[j]);
        }
      }
    });
    const json0 = {
      name: 'Combined Website Categories',
      data: combinData1,
    };
    const json1 = {
      name: 'Mobile Website Categories',
      data: mobileData,
    };
    const json2 = {
      name: 'PC Website Categories',
      data: pcData,
    };
    outObj.push(json0);
    outObj.push(json1);
    outObj.push(json2);

    return outObj;
  };

  processDataCategoryWise = () => {
    const filteredOutput = this.state.data[
      `${this.state.selectedRadioButton} - Last ${this.state.selectedDropdownValue}`
    ];
    let output = [];
    let slicedArray = [];
    if (filteredOutput) {
      slicedArray = filteredOutput.slice(
        0,
        this.state.selectedCatgoriesRadioButton
      );
      output = slicedArray.reduce(
        (accumulator, value) => ({ ...accumulator, [value.label]: true }),
        {}
      );
    }
    return output;
  };

  updateAsteriskStatus = asterisk => {
    if (asterisk === '*' && !this.state.showSingleAsterisk) {
      this.setState({ showSingleAsterisk: true });
    } else if (asterisk === '**' && !this.state.showDoubleAsterisk) {
      this.setState({ showDoubleAsterisk: true });
    }
  };

  processData = () => {
    const isMRIStudy = isMRISpecificStudy(this.props.study);
    const categoryWiseData = this.processDataCategoryWise();
    return ReportTypes.map(type => ({
      name: type.label,
      data: this.state.data[
        `${type.label} - Last ${this.state.selectedDropdownValue}`
      ]
        .filter(({ label }) => categoryWiseData[label])
        .map(({ label, value }) => {
          let asterisk;
          if (isMRIStudy) {
            asterisk = calculateMRIAsterisk(value.sample, this.props.study.wnt);
          } else {
            asterisk = calculateAsterisk(value.sample);
          }
          this.updateAsteriskStatus(asterisk);
          return {
            y: Number(value.pct.replace(/%/g, '')),
            dataLabels: { enabled: true, format: asterisk + value.pct },
            name: `${label} : ${type.label.replace(
              / Website Categories/g,
              ''
            )} `,
            label: `${type.label.replace(
              / Website Categories/g,
              ''
            )} - ${label}`,
            type: type.label.replace(/ Website Categories/g, ''),
            value: {
              index: value.index,
              sample: numberWithCommas(value.sample),
              weighted: numberWithCommas(value.weighted),
              pct: Math.round(Number(value.pct.replace(/%/g, ''))),
              asterisk,
            },
          };
        }),
    }));
  };

  handleClickEvent = event => {
    const _this = event.currentTarget.point;
    if (_this) {
      const type = _this.type;
      this.setState({
        event,
        displayTable: _this.type !== 'Combined',
        tableTitle: { name: _this.name, label: _this.label },
      });
      if (type !== 'Combined') {
        this.props.runReport(null, null, `${this.state.selectedDropdown}D`);
      }
    }
  };

  processTableData = () =>
    this.state.tableData[this.state.tableTitle.label]
      ? this.state.tableData[this.state.tableTitle.label].slice(0, 10)
      : [];

  renderCategories = () =>
    ReportCategories.map(category => (
      <p key={uuid()}>
        <input
          type="radio"
          id={`chartCategory${category}`}
          name="ChartCategory"
          checked={
            this.state.selectedCatgoriesRadioButton === category.toString()
          }
          onChange={this.handleCatRadioButtonChange}
          value={category}
        />
        <label htmlFor={`chartCategory${category}`}>
          <span>{category} Categories</span>
        </label>
      </p>
    ));

  renderDropdown = () =>
    ReportDropdown.map(({ key, value }) => (
      <option value={key} key={key}>
        {value}
      </option>
    ));

  renderReportTypes = () =>
    ReportTypes.map(type => (
      <div className="report-types">
        <img src={type.imgSrc} alt="" />
        <p key={uuid()}>
          <input
            type="radio"
            id={type.label}
            name="ReportType"
            checked={this.state.selectedRadioButton === type.label}
            onChange={this.handleReportTypeRadioButtonChange}
            value={type.label}
          />
          <label htmlFor={type.label}>
            <span>{type.label}</span>
          </label>
        </p>
      </div>
    ));

  render() {
    return (
      <div className="quick-report-graph-wrapper">
        <div className="large-12 column margin-top-10 margin-bottom-10">
          <div className="channel-category quick-report-dropdown display-inline large-4">
            <select
              onChange={this.handleDropdownChange}
              value={this.state.selectedDropdown}
            >
              {this.renderDropdown()}
            </select>
          </div>
          <div className="channel-category quick-report-radio display-inline cc-qr-radio">
            {this.renderCategories()}
          </div>
          <div className="quick-report-radio display-inline large-offset-3 large-9 cc-radio">
            {this.renderReportTypes()}
          </div>
        </div>
        <div className="column large-12">
          <BarChart
            chartType="bar"
            xAxisLabel="true"
            data={{
              rawData: this.arrangeDataCatWise(this.processData()),
              y: 'pct',
              tooltip: ['Sample', 'Weighted', 'Percent', 'Indx'],
            }}
            categories={Object.keys(this.processDataCategoryWise())}
            showLegend
            stackedChart
            stackDataLabels={this.state.showLabels}
            dataLabelFormat={checkAsterickFormate(
              '{y}%',
              this.state.showDoubleAsterisk,
              this.state.showSingleAsterisk
            )}
            tickPlacement="on"
            dataLabels
            chartStacking={null}
            seriesStacking="normal"
            chartColor={ChartColors}
            clickEvent={this.handleClickEvent}
          />
        </div>
        <ChannelCategoryTable
          event={this.state.event}
          visibility={this.state.displayTable}
          title={this.state.tableTitle}
          data={this.processTableData()}
          hideTable={this.hideTable}
        />
        <QuickReportFootNote
          studyInfo={this.props.study}
          className="padding-astrick font-12"
          showSingleAsterisk={this.state.showSingleAsterisk}
          showDoubleAsterisk={this.state.showDoubleAsterisk}
        />
      </div>
    );
  }
}

ChannelCategory.propTypes = {
  data: PropTypes.shape({}),
  handletitle: PropTypes.func,
  handleExportParams: PropTypes.func,
  runReport: PropTypes.func,
  trackerFn: PropTypes.func,
  study: PropTypes.shape({
    wnt: PropTypes.number,
  }),
  reportName: PropTypes.string,
};
